import { FC } from 'react'

import styled from 'styled-components'

import { tasks } from 'src/Constants/tikTokTasks'
import { variables } from 'src/Styled/variables'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

const SectionTitle = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI', sans-serif;
  font-size: ${variables.fontSize18};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const TaskTitle = styled.span`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI', sans-serif;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight600};
  line-height: 150%;
`

const Description = styled.p`
  color: ${({ theme }) => theme.color.darkGrey};
  font-family: 'Segoe UI', sans-serif;
  font-size: ${variables.fontSize14};
  font-weight: ${variables.fontWeight400};
  line-height: 150%;
  margin: 0;
`

interface TaskForCreatorsProps {
  commentType?: string | null
}

export const TaskForCreators: FC<TaskForCreatorsProps> = ({ commentType }) => {
  const task = commentType ? tasks.find((t) => t.value === commentType) : null

  if (!task) {
    return null
  }

  return (
    <Container>
      <SectionTitle>Task for creators</SectionTitle>
      <TaskTitle>{task.title}</TaskTitle>
      <Description>{task.artistDescription}</Description>
    </Container>
  )
}
